import React, { Component } from 'react';
import { CalendarContentTab, FormicaTimePickerDate } from './TimePickerDomain';
import CustomAbsoluteTimePicker from './CustomAbsoluteTimePicker';
import CustomRelativeTimePicker from './CustomRelativeTimePicker';
import LanguageUtil from '../../../util/LanguageUtil';

class DefaultTimePickerContainer extends Component<Props, State> {
  public state = new State();

  public render() {
    const { tab } = this.state;
    const { type } = this.props;
    return (
      <div className={'flex flex-col w-full'}>
        <div
          style={{ boxShadow: '1px 0px 4px 0px #0000000A inset' }}
          className={'flex shrink-0 gap-x-1 bg-[#F7F8FA] text-[#828282] w-full items-center h-8 rounded-[6px] p-1'}
        >
          <span
            className={`flex w-full h-full items-center rounded-[6px] justify-center text-md cursor-pointer hover:bg-white hover:text-f-black-1 ${tab == 'relative' && 'bg-white text-f-black-1 '}`}
            data-testid={`date_time_picker_${type}_Relative_button`}
            onClick={() => this.onClickTab('relative')}
          >
            {LanguageUtil.get({ id: 'common.label.relative', defaultMessage: 'Relative' })}
          </span>
          <span
            className={`flex w-full h-full items-center rounded-[6px] justify-center text-md cursor-pointer hover:bg-white hover:text-f-black-1 ${tab == 'absolute' && 'bg-white text-f-black-1 '}`}
            onClick={() => this.onClickTab('absolute')}
            data-testid={`date_time_picker_${type}_Absolute_button`}
          >
            {LanguageUtil.get({ id: 'common.label.absolute', defaultMessage: 'absolute' })}
          </span>
        </div>
        <div className={'flex w-full h-full'}>{this.getContent()}</div>
      </div>
    );
  }

  private getContent = () => {
    const { tab } = this.state;
    const { roundVisible } = this.props;
    switch (tab) {
      case 'absolute':
        return <CustomAbsoluteTimePicker date={this.props.date} setDate={this.props.setDate} />;
      case 'relative':
        return <CustomRelativeTimePicker date={this.props.date} setDate={this.props.setDate} type={this.props.type} roundVisible={roundVisible} />;
    }
  };

  private onClickTab = (tab: CalendarContentTab) => {
    this.setState({ tab });
  };
}

class State {
  tab: CalendarContentTab = 'relative';
}

interface Props {
  date: FormicaTimePickerDate;
  setDate: (date: FormicaTimePickerDate) => void;
  onApply: (startDate: FormicaTimePickerDate, endDate: FormicaTimePickerDate) => void;
  type: 'Start Date' | 'End Date';
  roundVisible?: boolean;
}

export default DefaultTimePickerContainer;
